import { IconButton } from 'component/Button'
import { RoundButton } from 'component/Button/RoundButton'
import { Image } from 'component/Image'
import { Modal } from 'component/Modal'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { session } from 'feature/widget/SessionStore'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Powered } from 'page/catalog/Powered/Powered'
import { demo } from 'page/catalog/store/CatalogStore'
import { standExit } from 'page/catalog/store/StandExitModalStore'
import css from './StandExitModal.module.scss'

export const StandExitModal = observer(() => {
  const { picture } = demo.it.widget

  const onContinue = useLatestCallback(async () => {
    standExit.close()
  })

  const onExit = useLatestCallback(async () => {
    standExit.close()
    session.stop()
  })

  return (
    <Modal open={true} width={640} onCancel={onContinue} closeButton={false}>
      <Space pad={16} right>
        <IconButton className={css.close} size={64} action={onContinue}>
          <Icon size={32} name="close" secondary />
        </IconButton>
      </Space>
      <Vertical pad={[0, 32, 24, 32]} center>
        <Space className={css.circle} width={120} height={120} pad={8} center round>
          <Space className={css.picture} width={104} height={104} center round>
            {picture && <Image src={picture} />}
            {!picture && <Icon size={64} name="person" tertiary />}
          </Space>
        </Space>
        <Gap height={48} />
        <Typo size={32} medium upper center>
          {i18n('exit.ExitTryOn')}
        </Typo>
        <Gap height={24} />
        <Typo size={24} center>
          {i18n('exit.FollowingWillBeDeleted')}
        </Typo>
        <Gap height={24} />
        <Space className={css.list} wide center>
          <Vertical gap={4}>
            <Space gap={12} height={36}>
              <Space className={css.dot} />
              <Typo size={24}>
                {i18n('exit.ItemData')}
              </Typo>
            </Space>
            <Space gap={12} height={36}>
              <Space className={css.dot} />
              <Typo size={24}>
                {i18n('exit.ItemSelfie')}
              </Typo>
            </Space>
            <Space gap={12} height={36}>
              <Space className={css.dot} />
              <Typo size={24}>
                {i18n('exit.ItemLooks')}
              </Typo>
            </Space>
          </Vertical>
        </Space>
        <Gap height={48} />
        <Vertical gap={12} wide>
          <RoundButton className={css.button} height={80} primary onClick={onContinue}>
            <Typo size={24} semi>
              {i18n('exit.Continue')}
            </Typo>
          </RoundButton>
          <RoundButton className={css.button} height={80} danger onClick={onExit}>
            <Typo size={24} semi>
              {i18n('exit.Exit')}
            </Typo>
          </RoundButton>
        </Vertical>
      </Vertical>
      <Space height={64} center>
        <Powered />
      </Space>
    </Modal>
  )
})
